import { z } from "zod";

/**
 * Preview payload: record of ratePlanId -> record of date (YYYY-MM-DD) -> cell.
 */
export const PreviewCellSchema = z.object({
    base: z.number(),
    adjusted: z.number(),
    is_child: z.boolean(),
});

export const PreviewSchema = z.record(
    z.string(),
    z.record(z.string(), PreviewCellSchema)
);

const ErrorItemSchema = z.object({
    row: z.number(),
    messages: z.array(z.string()),
});

const SummarySchema = z.object({
    rate_plan_count: z.number(),
    date_from: z.string(),
    date_to: z.string(),
    total_rows: z.number(),
    error_count: z.number(),
});

export const UploadResponseSchema = z.object({
    success: z.boolean(),
    data: z.object({
        import_id: z.string(),
        dp_active: z.boolean(),
        errors: z.array(ErrorItemSchema),
        summary: SummarySchema,
        rate_plan_names: z.record(z.string()).optional().default({}),
        room_type_names: z.record(z.string()).optional().default({}),
        plan_room_type: z.record(z.string()).optional().default({}),
        list: z
            .array(
                z.object({
                    room_type_id: z.string(),
                    rate_plan_id: z.string(),
                    start_date: z.string(),
                    end_date: z.string(),
                    price: z.number(),
                })
            )
            .optional()
            .default([]),
        preview: PreviewSchema,
    }),
});

export const ConfirmResponseSchema = z.object({
    success: z.boolean(),
    data: z.object({
        import_id: z.string(),
        batch_id: z.string(),
    }),
});

export const StatusResponseSchema = z.object({
    success: z.boolean(),
    data: z.object({
        status: z.enum([
            "previewed",
            "queued",
            "processing",
            "completed",
            "failed",
        ]),
        progress: z.number(),
        total: z.number(),
        processed: z.number(),
        failed: z.number(),
        error_message: z.string().nullable(),
    }),
});

export type PreviewCell = z.infer<typeof PreviewCellSchema>;
export type Preview = z.infer<typeof PreviewSchema>;
export type UploadResponse = z.infer<typeof UploadResponseSchema>;
export type ConfirmResponse = z.infer<typeof ConfirmResponseSchema>;
export type StatusResponse = z.infer<typeof StatusResponseSchema>;
